export const STRINGS = {
  app_name: "app_name",
  vsa: "vsa",
  vehicle_safety_audit: "vehicle_safety_audit",
  vsa_scan_vin_title: "vsa_scan_vin_title",
  vsa_enter_vin_title: "vsa_enter_vin_title",
  vsa_help_options_title: "vsa_help_options_title",
  vsa_manual_vin_input_title: "vsa_manual_enter_vin_title",
  vsa_scan_vin_location_instruction: "vsa_scan_vin_location_instruction",
  unable_to_scan: "unable_to_scan",
  vsa_vin_location: "vsa_vin_location",
  vsa_scan_vin_barcode_or_qr: "vsa_scan_vin_barcode_or_qr",
  vsa_scan_vin_instruction: "vsa_scan_vin_instruction",
  vsa_help_option_enter_vin: "vsa_help_option_enter_vin",
  vsa_vin_length_not_match_warning: "vsa_vin_length_not_match_warning",
  vsa_vin_special_char_warning: "vsa_vin_special_char_warning",
  tv_current_status: "tv_current_status",
  status_grounded: "status_grounded",
  status_active: "status_active",
  certify_repairs: "certify_repairs",
  tv_certify_repairs_description: "tv_certify_repairs_description",
  scan_another_vin: "scan_another_vin",
  vsa_scan_this_vehicle_description: "vsa_scan_this_vehicle_description",
  vsa_scan_another_vehicle_description: "vsa_scan_another_vehicle_description",
  submit: "submit",
  rb_repairs_made: "rb_repairs_made",
  rb_repairs_not_made: "rb_repairs_not_made",
  vehicle_status_changed_to: "vehicle_status_changed_to",
  view_issues: "view_issues",
  view_issues_description: "view_issues_description",
  start_vehicle_audit: "start_vehicle_audit",
  how_to_start_vsa_description_0: "how_to_start_vsa_description_0",
  how_to_start_vsa_description_1: "how_to_start_vsa_description_1",
  how_to_start_vsa_description_2: "how_to_start_vsa_description_2",
  move_to: "move_to",
  vsa_front_side: "vsa_front_side",
  vsa_passenger_side: "vsa_passenger_side",
  vsa_back_side: "vsa_back_side",
  vsa_driver_side: "vsa_driver_side",
  vsa_cab: "vsa_cab",
  vsa_general: "vsa_general",
  inspect: "inspect",
  no_issues: "no_issues",
  choose_all_issues_that_are_present: "choose_all_issues_that_are_present",
  report: "report",
  issue_vsa: "issue_vsa",
  issues: "issues",
  report_issue_button: "report_issue_button",
  audit_summary: "audit_summary",
  audit_summary_inspection_results: "audit_summary_inspection_results",
  audit_summary_full_report: "audit_summary_full_report",
  audit_summary_issues_found: "audit_summary_issues_found",
  submit_report: "submit_report",
  acknowledge_inspect_description: "acknowledge_inspect_description",
  no_issue_vehicle: "no_issue_vehicle",
  no_issue_reported: "no_issue_reported",
  unsafe_to_drive_warning: "unsafe_to_drive_warning",
  vin_not_recognize_warning: "vin_not_recognize_warning",
  something_went_wrong_warning: "something_went_wrong_warning",
  vehicle_inactive_warning: "vehicle_inactive_warning",
  invalid_vin_warning: "invalid_vin_warning",
  take_photo_retake: "take_photo_retake",
  take_photo_use_photo: "take_photo_use_photo",
  take_photo_issue: "take_photo_issue",
  take_photo_title: "take_photo_title",
  uncheck_defect_description: "uncheck_defect_description",
  uncheck_defect_cancel: "uncheck_defect_cancel",
  uncheck_defect_confirm: "uncheck_defect_confirm",
  urgent_help: "urgent_help",
  back_press_title: "back_press_title",
  back_press_description: "back_press_description",
  back_press_primary: "back_press_primary",
  back_press_secondary: "back_press_secondary",
  training_title: "training_title",
  training_description: "training_description",
  training_button: "training_button",
  status_changed_to_active: "status_changed_to_active",
  vehicle_unsafe_to_drive: "vehicle_unsafe_to_drive",
  something_went_wrong: "something_went_wrong",
  no_internet: "no_internet",
};

export default STRINGS;
